export const CALLIGRAFIA = 'calligrafia';
export const BOR_BORITO = 'bor_borito';
export const LA_FONTANA = 'la_fontana_di_stile';
export const DEKOR = 'dekor_borito';
export const WEDDING = 'wedding_sensation';
export const FINESSA = 'finessa';
export const CANVAS_DREAM = 'canvas_dream';
export const LEATHER_UPPERCASE = 'Leather';
export const CALLIGRAFIA_UPPERCASE = 'Calligrafia';
export const FOTOS_BORITO = 'fotos_borito';

export function autofillDisableDropCoverType() {
  return [
    BOR_BORITO,
  ];
}

export function disableDropCoverType() {
  return [
    CALLIGRAFIA,
    BOR_BORITO,
  ];
}

export function coverWithoutSpine() {
  return [
    LA_FONTANA,
    DEKOR,
    WEDDING,
    FINESSA,
    CALLIGRAFIA,
    CANVAS_DREAM,
  ];
}

export function skipImageDropToCover() {
  return [
    CALLIGRAFIA_UPPERCASE,
    LEATHER_UPPERCASE,
  ];
}

export function coversWithText() {
  return [
    FOTOS_BORITO,
  ];
}

export function coverWithTextAndWithoutSpine() {
  return [
    CALLIGRAFIA,
  ];
}

export function coverWithOnlyAutofillLayout() {
  return [
    FOTOS_BORITO,
  ];
}

export function horizontalToolbasCovers() {
  return [
    DEKOR,
  ];
}

export function insertTextHelpCover() {
  return [
    CALLIGRAFIA,
  ];
}



// WEBPACK FOOTER //
// ./src/helpers/coverHelper.js